import type { CommandType, FocusBucket, PriorityLabel } from "@ceo-cmd/shared";

export const BUCKET_LABELS: Record<FocusBucket, string> = {
  act_now: "Act Now",
  decision_required: "Decision Required",
  waiting: "Waiting",
  at_risk: "At Risk",
  monitoring: "Monitoring",
  all_active: "All Active",
};

export function formatMoney(value: number, currency = "USD"): string {
  if (value >= 1_000_000) return `$${(value / 1_000_000).toFixed(1)}M`;
  if (value >= 1_000) return `$${(value / 1_000).toFixed(0)}K`;
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
    maximumFractionDigits: 0,
  }).format(value);
}

export function priorityClass(priority: PriorityLabel): string {
  switch (priority) {
    case "critical":
      return "bg-red-500/15 text-red-500";
    case "high":
      return "bg-amber-500/15 text-amber-500";
    case "low":
      return "bg-muted text-muted-foreground";
    default:
      return "bg-brand-soft text-brand";
  }
}

export function dueLabel(iso?: string): string {
  if (!iso) return "No due date";
  const due = new Date(iso);
  const start = new Date();
  start.setHours(0, 0, 0, 0);
  const end = new Date(start);
  end.setDate(end.getDate() + 1);
  if (due < start) return "Overdue";
  if (due < end) return "Due today";
  return due.toLocaleDateString();
}

export function typeLabel(type: CommandType): string {
  return type.replace(/_/g, " ");
}
